module.exports = __webpack_public_path__ + "img/collection-weddingRingsBlack@2x.869c698.jpg";